/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-30 09:51:22
 **/

import { ModalID } from "@/frameworks/core/commons";
import { _T } from "@rfice/language";
import { ModalPopup, Row, Typography, useModal } from "@/frameworks/designStuff/components";

export default function useSimplePopup() {
	const modal = useModal();
	return (id: ModalID, message: string) => {
		modal.show({
			id,
			content: (
				<ModalPopup modalID={id} confirmText={_T("확인")} onConfirm={(_, hide) => hide()} fitContent>
					<Row style={{ width: "100%", height: "52px" }}>
						<Typography typoSize="Title1">{message}</Typography>
					</Row>
				</ModalPopup>
			)
		});
	};
}
